import React from "react";

const MnlArrow = props => (
  <svg width={10} height={8} className={props.rotated ? 'rotated' : null}>
    <path fill={props.color ? props.color : "#000000"} d="M1.175.367L5 4.183 8.825.367 10 1.542l-5 5-5-5z" />
  </svg>
)

export default MnlArrow;
